import { PropTypes } from 'react';

import SOURCES from 'ub/ui/asset-library/asset-sources';
import { TYPES } from 'ub/ui/asset-library/asset-types';

export const sortByPropType = PropTypes.oneOf(['date', 'filename', 'filesize']);

export const assetSourcePropType = PropTypes.oneOf(Object.keys(SOURCES));

export const assetTypePropType = PropTypes.oneOf(Object.keys(TYPES));

export const itemsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    type: assetTypePropType.isRequired,
    id: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
    fullUrl: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,

    asset: PropTypes.shape({
      company_id: PropTypes.number,
      content_content_type: PropTypes.string.isRequired,
      content_file_name: PropTypes.string.isRequired,
      content_file_size: PropTypes.number.isRequired,
      content_url_small: PropTypes.string.isRequired,
      content_url: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      unique_url: PropTypes.string.isRequired,
      uuid: PropTypes.string.isRequired,
    }),
  })
);



// WEBPACK FOOTER //
// ./src/components/asset-library/prop-types.js